import React, { PropsWithChildren } from 'react'

import { PropsWithClassName } from '@helper/PropsWithClassName'

import { Root } from './IconX.styles'

interface Props extends PropsWithClassName {
  size?: string
  color?: string
}

const IconX: React.FC<PropsWithChildren<Props>> = (
  props: PropsWithChildren<Props>
): React.JSX.Element => {
  const currentSize = props.size ?? '24'
  const currentColor = props.color ?? '#292929'

  return (
    <Root
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={currentSize}
      height={currentSize}
      fill="none"
      className={props.className}
      data-testid={'icon-x-root'}
    >
      <path
        d="M18 6L6 18M6 6l12 12"
        stroke={currentColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Root>
  )
}

export { IconX }
